import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-alice-carousel/lib/alice-carousel.css';
import Advertisment from '../advertisement/Advertisment';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import UserScreenSize from '../../common/useScreenSize/UserScreenSize';
function Addbanner() {
    const navigate = useNavigate();
    const { width } = UserScreenSize();
    const filterdata = useSelector((state) => state?.auth?.bannerData);
    const advertisementData = useSelector((state) => state?.auth?.advertisement_data);



    return (
        <div className="w-full max-w-[1250px] mb-5 mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-3 max-sm:!mb-2">
            <Advertisment />
            <div className="dots banner-slider relative clearfix">

                {width < 900 ?
                    <>
                        <Swiper
                            spaceBetween={30}
                            centeredSlides={true}
                            autoplay={{
                                delay: 2000,
                                pauseOnMouseEnter: true,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                dynamicBullets: true,
                                clickable: true,
                            }}
                            loop={true}
                            navigation={false}
                            modules={[Autoplay, Pagination, Navigation]}
                           className="mySwiper w-[calc(100%-0%)] mb-2 sm:float-right mb-0 sm:w-[calc(100%-52%)] md:w-[calc(100%-32%)]  lg:w-[calc(100%-350px)]"
                        >
                            {filterdata?.length && filterdata?.map((item) => (
                                item?.status &&
                                <SwiperSlide>
                                    <div className='border p-1 rounded shadow'>
                                        <img
                                            key={item.id}
                                            src={item.upload_banner}
                                            alt={`Slide ${item.id}`}
                                            onDragStart={(e) => e.preventDefault()}
                                            onClick={() =>
                                                navigate(`/franchise-opportunity/${item.id}`, {
                                                    state: { item: item },
                                                })
                                            }
                                            role="presentation"
                                            className=" w-full h-[270px] object-cover rounded max-lg:h-[210px] max-sm:h-[auto]"
                                        />
                                    </div></SwiperSlide>
                            ))}

                        </Swiper>
                        <div className='border p-1 rounded h-[auto] w-[100%] sm:float-left mb-0 sm:w-[50%] md:w-[30%] h-[220px]  lg:w-[336px] lg:h-[280px]'>
                            {
                                advertisementData.map((item) => {
                                    if (
                                        ["SideBanner1"].includes(item?.category)
                                    ) {
                                        return (
                                            <div key={item.id} className="h-[100%]">
                                                <a
                                                    key={item?.index}
                                                    href={item?.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"

                                                >
                                                    <img
                                                        className="rounded h-[100%] w-full object-cover"
                                                        src={item?.image || "/default-image.jpg"}
                                                        alt={item?.category || "Advertisement"}
                                                    />
                                                </a>
                                            </div>
                                        );
                                    }
                                })

                            }
                        </div>


                    </> : <> 
                    <div className='border p-1 rounded w-[100%] sm:float-left mb-0 sm:w-[50%] md:w-[30%] h-[220px] lg:w-[336px] lg:h-[280px]'>
                    
                        {
                            advertisementData.map((item) => {
                                if (
                                    ["SideBanner1"].includes(item?.category)
                                ) {
                                    return (
                                        <div key={item.id} className="h-[100%]">
                                            <a
                                                key={item?.index}
                                                href={item?.url}
                                                target="_blank"
                                                rel="noopener noreferrer"

                                            >
                                                <img
                                                    className="rounded h-[100%] w-full object-cover"
                                                    src={item?.image || "/default-image.jpg"}
                                                    alt={item?.category || "Advertisement"}
                                                />
                                            </a>
                                        </div>
                                    );
                                }
                            })

                        }
                    </div>

                        <Swiper
                            spaceBetween={30}
                            centeredSlides={true}
                            autoplay={{
                                delay: 2000,
                                pauseOnMouseEnter: true,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                dynamicBullets: true,
                                clickable: true,
                            }}
                            loop={true}
                            navigation={false}
                            modules={[Autoplay, Pagination, Navigation]}
                               className="mySwiper w-[calc(100%-0%)] mb-2 sm:float-right mb-0 w-[calc(100%-52%)] md:w-[calc(100%-32%)] lg:w-[calc(100%-350px)]"
            
                        >
                            {filterdata?.length && filterdata?.map((item) => (
                                item?.status &&
                                <SwiperSlide>
                                    <div className='border p-1 rounded shadow'>
                                        <img
                                            key={item.id}
                                            src={item.upload_banner}
                                            alt={`Slide ${item.id}`}
                                            onDragStart={(e) => e.preventDefault()}
                                            onClick={() =>
                                                navigate(`/franchise-opportunity/${item.id}`, {
                                                    state: { item: item },
                                                })
                                            }
                                            role="presentation"
                                            className=" w-full h-[270px] object-cover rounded max-lg:h-[210px] max-sm:h-[auto]"
                                        />
                                    </div></SwiperSlide>
                            ))}

                        </Swiper>
                    </>}
            </div>


        </div>
    );
}

export default Addbanner
